import { PROPERTY_SORTS, type PropertySort } from '@resolute/schema';

/**
 * Sort is the one vocabulary here with no upstream source: it describes how
 * THIS app orders a result set (see `sortItems` in the API's cpzone-adapter),
 * not anything CPzone publishes, so `/filter-options` has no list for it.
 *
 * Every other vocabulary — property types, cities, BHK configs, listing
 * statuses, categories, areas, amenities, possession years — is resolved live
 * from `/filter-options`. For labels use `useFilterLabels`; for option lists
 * read the query directly (see `use-filter-labels.ts` and the hero search's
 * `useCategoryConfig`).
 */
const SORT_LABELS: Record<PropertySort, string> = {
  relevance: 'Relevance',
  'price-asc': 'Price: Low to High',
  'price-desc': 'Price: High to Low',
  newest: 'Newest first',
  'area-desc': 'Largest area',
};

export const SORT_OPTIONS = PROPERTY_SORTS.map((v) => ({ value: v, label: SORT_LABELS[v] }));
